
import { createVNode, defineComponent, onMounted, onUnmounted, ref, watch } from 'vue';
import { OioButton, OioInput, OioMessage, OioModal, OioSelect, OioSpin } from '@kunlun/vue-ui-antd';
import {
  ExclamationCircleOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  TagFilled
} from '@ant-design/icons-vue';
import XLSX from 'xlsx';
import { Modal } from 'ant-design-vue';
import { cloneDeep } from 'lodash-es';
import { removeDecimalZero } from '../../../../utils/number';
import { vxeTableRemoveZeroFormatter } from '../../../../utils/fotmatter';
import { exportModelExcelFile } from '../../../../utils/excel';

export default defineComponent({
  name: 'AfterSalesRefundsReturn',
  methods: { removeDecimalZero, vxeTableRemoveZeroFormatter },
  components: {
    OioButton,
    OioModal,
    OioInput,
    ExclamationCircleOutlined,
    TagFilled,
    FullscreenOutlined,
    FullscreenExitOutlined,
    OioSelect,
    OioSpin
  },
  props: ['importReturnItems', 'updateOne', 'setFormData', '_formData', 'mountedProcessFlag', '_instance', 'deleteEvent', 'portActionBtnShow', 'DoubleSourceFindInvisible'],
  setup(props) {
    const sortOptions = ref([
      {
        value: 'order_desc',
        label: '按下单顺序排序'
      },
      {
        value: 'activity_group',
        label: '按活动分组排序'
      }
    ]);
    const priceTypeEnumList = ref<any>({
      EX_FACTORY_PRICE: '出厂价',
      PRICE: '一口价',
      REAL_PRICE: '实价',
      RETAIL_PRICE: '零售价'
    });
    const InventoryStatus = ref({
      ALL_SATISFIED: '全部满足',
      PARTIALLY_FULFIL: '部分满足',
      NOT_SATISFIED: '不满足'
    });

    const tableRef = ref<any>();
    const errorTableRef = ref<any>();
    const sortType = ref('order_desc');
    const errorData = ref<any[]>([]);
    const selectRow = ref<any>();
    const selectRecords = ref<any[]>([]);
    const isAllChecked = ref(false);
    const isIndeterminate = ref(false);
    const searchVal = ref('');
    const errorModal = ref<boolean>(false);
    const reasonOptions = ref<any[]>([]);
    const tips = ref('');
    const addLoading = ref(false);
    const tableLoading = ref(false);
    const importLoading = ref(false);
    const exportLoading = ref(false);
    const dataSource = ref<any[]>([]);
    const totalAmount = ref(0);

    const contentRef = ref();
    const isFullscreen = ref(false);
    const onFullscreenChange = () => {
      isFullscreen.value = Boolean(document.fullscreenElement);
    };
    onMounted(() => {
      document.addEventListener('fullscreenchange', onFullscreenChange);
      if (props.deleteEvent) {
        props.deleteEvent.subscribe(async ({ data }) => {
          const needRemove = dataSource.value.find((item) => item.outCode === data);
          dataSource.value.splice(dataSource.value.indexOf(needRemove), 1);
          tableRef.value.reloadData(dataSource.value);
          if (dataSource.value.length === 0) {
            totalAmount.value = 0;
          } else {
            totalAmount.value -= needRemove.applyRefundAmount;
          }
        });
      }
    });
    onUnmounted(() => {
      document.removeEventListener('fullscreenchange', onFullscreenChange);
    });
    const toggleFullscreen = () => {
      if (isFullscreen.value) {
        document.exitFullscreen();
      } else {
        contentRef.value?.requestFullscreen();
      }
    };
    const getPopupContainer = (triggerNode: HTMLElement) => {
      let curNode = triggerNode;
      while (curNode) {
        if (curNode.id === 'ASRR-content') {
          return curNode;
        }
        curNode = curNode.parentNode as HTMLElement;
      }
      return document.body;
    };

    const checkboxChangeEvent = () => {
      const $table = tableRef.value;
      if ($table) {
        isAllChecked.value = $table.isAllCheckboxChecked();
        isIndeterminate.value = $table.isAllCheckboxIndeterminate();
        selectRecords.value = $table.getCheckboxRecords();
      }
    };

    const importDataEvent = () => {
      // 弹出选择文件弹窗
      const input = document.createElement('input');
      input.type = 'file';
      input.style.display = 'none';

      // sheet_to_array的实现
      function parseExcelSheetToArrays(sheet) {
        const Range = {
          x1: sheet['!ref'].split(':')[0].match(/^[A-Z]+/)[0],
          y1: sheet['!ref'].split(':')[0].match(/\d+$/)[0],
          x2: sheet['!ref'].split(':')[1].match(/^[A-Z]+/)[0],
          y2: sheet['!ref'].split(':')[1].match(/\d+$/)[0]
        };

        let tableDataArr: any = [];
        for (let y = Range.y1; y <= Range.y2; y++) {
          // 行遍历
          let rowArr: any[] = [];
          for (let x = Range.x1.charCodeAt(); x <= Range.x2.charCodeAt(); x++) {
            // 列遍历 TD:暂时只支持到A~Z列，有需要的自己优化
            let position = String.fromCharCode(x) + y;
            // @ts-ignore
            rowArr.push(sheet?.[position]?.v ?? null);
          }
          tableDataArr.push(rowArr);
        }
        return tableDataArr;
      }

      const handleChangeFile = (e) => {
        const file = <File>e.target.files[0];
        const format = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
        const importFileFormat = ['xlsx', 'xls'];
        if (!importFileFormat.includes(format)) {
          OioMessage.error('仅支持上传excel文件');
        } else {
          const reader = new FileReader();
          reader.onload = async (e: any) => {
            try {
              const data = e.target.result;
              const workbook = XLSX.read(data, { type: 'binary', cellDates: true });
              const sheetNames = workbook.SheetNames;
              const worksheet = workbook.Sheets[sheetNames[0]];
              // const sheetList = XLSX.utils.sheet_to_json(worksheet, { defval: '', raw: false }) as any[];
              const arr = parseExcelSheetToArrays(worksheet);
              let str = '';
              arr.forEach((row, rowIndex) => {
                // if (rowIndex > 0) {
                row.forEach((col, colIndex) => {
                  if (colIndex !== row.length - 1) {
                    str += `${col}\t`;
                  } else {
                    str += `${col}@#@#`;
                  }
                });
                // }
              });
              importLoading.value = true;
              tableLoading.value = true;
              await queryData(str);
            } catch (error) {
              console.error(error);
            } finally {
              importLoading.value = false;
              tableLoading.value = false;
            }
          };
          reader.readAsBinaryString(file);
        }
        // 需要清除input的value，不然相同的文件无法上传多次
        if (input.value) {
          input.value = '';
        }
      };

      input.onchange = handleChangeFile;
      input.click();
    };

    const insertEvent = async (row: any) => {
      const $table = tableRef.value;
      if ($table) {
        const record = {};
        const { row: newRow } = await $table.insertAt(record, row);
        await $table.setEditCell(newRow, 'outCode');
        dataSource.value.push(newRow);
      }
    };

    const removeRow = ({ row, rowIndex }) => {
      Modal.confirm({
        title: '确认删除吗?',
        icon: createVNode(ExclamationCircleOutlined),
        async onOk() {
          tableLoading.value = true;
          try {
            dataSource.value.splice(rowIndex, 1);
            tableRef.value.reloadData(dataSource.value);
            if (dataSource.value.length === 0) {
              totalAmount.value = 0;
            }
            if (row.outCode) {
              const res = await props.updateOne(row);
              totalAmount.value = res.refundAmount ?? 0;
            }
          } finally {
            tableLoading.value = false;
          }
        }
      });
    };

    const queryData = async (str) => {
      try {
        addLoading.value = true;
        tableLoading.value = true;

        let res = await props.importReturnItems(str);
        dataSource.value = res.returnDetailProxySaleSkus;
        tableRef.value.reloadData(dataSource.value);

        if (res.errMessages?.length) {
          tips.value = res.errMessages[0];
          const obj = {
            msg: res.errMessages[0]
          };
          errorData.value.unshift(...res.errMessages.map((msg) => ({ msg })));
          errorTableRef.value?.reloadData(errorData.value);
        }
        res?.refundAmount && (props._formData.refundAmount = res.refundAmount);
        res?.refundType && (props._formData.refundType = res.refundType);
        res?.sourceType && (props._formData.sourceType = res.sourceType);
        searchVal.value = '';
      } finally {
        addLoading.value = false;
        tableLoading.value = false;
      }
    };

    const onChangeRow = async ({ row, rowIndex }) => {
      const copy = cloneDeep(dataSource.value);
      const index = copy.findIndex((i) => row.outCode && i.outCode === row.outCode);
      if (index !== -1) {
        copy.splice(index, 1);
        if (copy.some((i) => row.outCode && i.outCode === row.outCode)) {
          OioMessage.warning('当前ERP商品编码已存在列表中');
          return;
        }
      }
      try {
        addLoading.value = true;
        tableLoading.value = true;

        const res = await props.updateOne(row);
        if (res.errMessages?.length) {
          tips.value = res.errMessages[0];
          const obj = {
            outCode: row.outCode,
            msg: res.errMessages[0]
          };
          errorData.value.unshift(...res.errMessages.map((msg) => ({ msg })));
          errorTableRef.value.reloadData(errorData.value);
        } else {
          dataSource.value[rowIndex] = res.returnDetailProxySaleSkus?.[res.returnDetailProxySaleSkus?.length - 1] ?? {};
          tableRef.value.reloadData(dataSource.value);
        }
        totalAmount.value = res.refundAmount;
        tableRef.value?.clearEdit();
      } finally {
        addLoading.value = false;
        tableLoading.value = false;
      }
    };

    const onActivityChange = async (value, scope) => {
      scope.row.deliAriesActivities.forEach((item) => {
        item.isChecked = item.actName === value;
      });

      await onChangeRow(scope);
    };

    const onChangeReason = async (scope, val) => {
      scope.row.reason = props._formData.allReason?.find((item) => item.reason === val) ?? {};

      await onChangeRow(scope);
    };

    const showErrorModal = () => {
      errorModal.value = true;
    };

    const onSortChange = (value) => {
      // const copyData = cloneDeep(dataSource);
      // if (value === 'order_desc') {
      // } else {
      // }
      // props.reloadDataSource(copyData);
    };

    const exportDataEvent = () => {
      try {
        exportLoading.value = true;
        // @ts-ignore
        const model = props._instance.runtimeSubviewContext.model;
        exportModelExcelFile(
          dataSource.value,
          {
            ...model,
            modelFields: model.modelFields
          },
          {
            filename: `退入商品明细_${Date.now()}.xlsx`,
            addLineNumber: true,
            customFieldsParser: {
              reason(val) {
                return { value: val?.reason ?? '' };
              }
            }
          }
        );
      } catch (error) {
        throw error;
      } finally {
        exportLoading.value = false;
      }
    };

    watch(
      dataSource,
      (value) => {
        props.setFormData(value);
      },
      { deep: true }
    );
    watch(
      () => props._formData.returnDetailProxySaleSkus,
      (value) => {
        dataSource.value = value ?? [];
      },
      { deep: true, immediate: true }
    );
    watch(
      () => props._formData.refundAmount,
      (value) => {
        totalAmount.value = value ?? 0;
      },
      { immediate: true }
    );
    watch(
      () => props._formData.reverseType,
      () => {
        if (!props.mountedProcessFlag) return;
        dataSource.value = [];
        tableRef.value.reloadData(dataSource.value);
        totalAmount.value = 0;
      }
    );

    return {
      tableRef,
      errorData,
      errorTableRef,
      errorModal,
      selectRow,
      selectRecords,
      isAllChecked,
      isIndeterminate,
      searchVal,
      reasonOptions,
      onChangeReason,
      checkboxChangeEvent,
      importDataEvent,
      insertEvent,
      priceTypeEnumList,
      onChangeRow,
      queryData,
      showErrorModal,
      removeRow,
      sortOptions,
      tips,
      addLoading,
      tableLoading,
      importLoading,
      exportLoading,
      onSortChange,
      sortType,
      InventoryStatus,
      dataSource,
      totalAmount,
      isFullscreen,
      toggleFullscreen,
      contentRef,
      onActivityChange,
      getPopupContainer,
      exportDataEvent
    };
  }
});
